import { FlexibleContentProps } from '@sola/schema/lib/schema.ts';

import { FundQueryParams } from '../../../utils/query-params.tsx';

export enum DonateVariants {
  default = 'default',
  grid = 'grid',
}

// CommitmentFrequencyEnum
export enum DonateFrequency {
  OneTime = 'OneTime',
  Monthly = 'Monthly',
  Annually = 'Annually',
}

export interface DonationLimits {
  min: number;
  max: number;
}

export type DonateConfig = {
  donationLimits: {
    min: number;
    max: number;
  };
  defaultFrequency: DonateFrequency;
  enabledFrequencies: DonateFrequency[];
};

export interface DonateErrorObject {
  title?: {
    key: string;
    payload?: { [key: string]: string | number };
  };
  message: {
    key: string;
    payload?: { [key: string]: string | number };
  };
}

export interface DonateState {
  donateFrequency: DonateFrequency;
  selectedAmounts: Record<DonateFrequency, string>;
  suggestedAmounts?: Record<DonateFrequency, string>;
  otherAmounts: Record<DonateFrequency, string>;
  otherSelected: boolean;
  isSubmitting: boolean;
  submitError: string | DonateErrorObject | null;
}

export enum DonateActionEnum {
  SET_FREQUENCY = 'SET_FREQUENCY',
  SET_AMOUNT = 'SET_AMOUNT',
  SET_OTHER_AMOUNT = 'SET_OTHER_AMOUNT',
  SET_OTHER_SELECTED = 'SET_OTHER_SELECTED',
  SET_SUBMITTING = 'SET_SUBMITTING',
  SET_SUBMIT_ERROR = 'SET_SUBMIT_ERROR',
}

export type DonateAction =
  | { type: DonateActionEnum.SET_FREQUENCY; payload: DonateFrequency }
  | {
      type: DonateActionEnum.SET_AMOUNT;
      payload: { frequency: DonateFrequency; amount: string };
    }
  | {
      type: DonateActionEnum.SET_OTHER_AMOUNT;
      payload: { frequency: DonateFrequency; amount: string };
    }
  | { type: DonateActionEnum.SET_OTHER_SELECTED; payload: boolean }
  | { type: DonateActionEnum.SET_SUBMITTING; payload: boolean }
  | {
      type: DonateActionEnum.SET_SUBMIT_ERROR;
      payload: string | DonateErrorObject | null;
    };

export interface DonateContextType {
  state: DonateState;
  dispatch: React.Dispatch<DonateAction>;
  refs: {
    [DonateFrequency.OneTime]: React.MutableRefObject<HTMLInputElement>;
    [DonateFrequency.Monthly]: React.MutableRefObject<HTMLInputElement>;
    [DonateFrequency.Annually]: React.MutableRefObject<HTMLInputElement>;
  };
  props: FlexibleContentProps;
  variant: DonateVariants;
  config: DonateConfig;
  fundParams?: FundQueryParams;
}
